import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { AlertTriangleOutline } from '@lyearn/icons';
import { Stack, Tooltip } from '@lyearn/ui';
import { TooltipPlacements } from '@lyearn/ui/dist/esm/Tooltip/types';

type AIInfoTooltipProps = {
  placement?: TooltipPlacements;
  classes?: {
    root?: string;
    icon?: string;
  };
};

const TOOLTIP_CLASSES = {
  tooltip: 'w-[16.4rem] p-0 text-center px-10 py-8',
};

function AIInfoTooltip(props: AIInfoTooltipProps) {
  const { placement = 'left', classes } = props;
  const { t } = useTranslation();

  return (
    <Tooltip
      classes={TOOLTIP_CLASSES}
      placement={placement}
      title={t('AI:AIResponsesCanBeInaccurateMisleading')}>
      <Stack className={classes?.root}>
        <AlertTriangleOutline
          className={cn('text-icon-placeholder hover:text-icon-secondary', classes?.icon)}
        />
      </Stack>
    </Tooltip>
  );
}

export default AIInfoTooltip;
